// qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/utils/connectorApi.js
//
// Centralized base-URL + token helper for the Connector Handler service.
//
// Every admin surface that talks to the Connector (OAuth flows,
// operations registry, connector definitions) routes through here,
// so a future migration to a different host shape is a one-file
// change.
//
// This helper is deliberately Connector-only. AutoBot talks to a
// different domain (`autobot2`), and its callers should get their
// own helper rather than adding a mode flag to this one.

const BACKEND_BASE_ENV_PART =
  `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

/**
 * Build the Connector Handler base URL for a given region.
 *
 *   buildConnectorBase("us")   → https://us.connector-handler2.<env>
 *   buildConnectorBase("in")   → https://in.connector-handler2.<env>
 *
 * Missing / blank region falls back to "us", matching the previous
 * inline behaviour in oauthApi.js and operationsApi.js.
 */
export function buildConnectorBase(region) {
  const regionLower = (region || "us").toLowerCase();
  return `https://${regionLower}.connector-handler2.${BACKEND_BASE_ENV_PART}`;
}

/**
 * The bearer token the admin sends on every authenticated call.
 *
 * Reads from localStorage under the key the rest of the admin uses.
 * Returns an empty string when no token is present; the backend
 * rejects an empty Authorization header with 401, and the caller's
 * error handling surfaces that.
 */
export function getAdminToken() {
  return localStorage.getItem("token") || "";
}